module.exports = __webpack_public_path__ + "media/luxury-2026/round-hill-estate-aerial-960-c04b5599.jpg";